export type ShellProps = {
  userEmail: string;
  tenantId: string | undefined;
  onSignOut: () => void;
};

/**
 * The authenticated app shell. Session/tenant info only — the real fleet
 * tree/reports/inbox views land in PEK-95; this just reserves their place.
 */
export function Shell({ userEmail, tenantId, onSignOut }: ShellProps) {
  return (
    <div className="shell">
      <header className="shell-header">
        <span>peek</span>
        <span className="shell-session" data-testid="session-info">
          {userEmail} · tenant {tenantId ?? "resolving…"}
        </span>
        <button type="button" onClick={onSignOut}>
          Sign out
        </button>
      </header>
      <main className="shell-placeholder" data-testid="tenant-data">
        <p>Fleet tree, reports, and the needs-input inbox arrive in PEK-95.</p>
        <p>Your session is authenticated and your tenant is resolved — this is where they'll render.</p>
      </main>
    </div>
  );
}
